import {factoryShipgroupFetch} from "./index";

export const getOrderDeadlines = async () => {
    const url = `/order_deadline/order_deadlines/v1/all`;
    return factoryShipgroupFetch(url);
}
